export function getConnectionEffectiveType() {
    const connection =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;

    return connection?.effectiveType || 'undefined';
}
